<template>
  <div id="sondage">
    <section class="section section-lg">
      <div class="container">
        <div class="row justify-content-center text-center mb-lg">
          <div class="col-lg-8">
            <h2 class="display-3">Du concret. Pas du bruit.</h2>
            <p class="lead text-muted">
              Des campagnes visibles, des interactions réelles, des résultats mesurables. Voici ce que nos actions produisent sur le terrain.
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-left"
            data-aos-duration="1300"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/satisfait.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire"
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">CLIENTS SATISFAITS</div>
                  <small class="h6 text-muted">
                    97% des clients satisfaits de leurs campagnes de communication terrain.
                  </small>
                </h5>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-left"
            data-aos-duration="1300"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/interaction.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire"
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">INTERACTIONS DIRECTES</div>
                  <small class="h6 text-muted">
                    +2,3 Millions interactions générées avec les populations sur le terrain.
                  </small>
                </h5>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/campagnes.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire."
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">CAMPAGNES RÉALISÉES </div>
                  <small class="h6 text-muted">
                    +1100 campagnes déployées à travers le Bénin.
                  </small>
                </h5>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/ville.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire"
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">VILLES PARCOURUES</div>
                  <small class="h6 text-muted">
                    +35 villes couvertes par nos dispositifs publicitaires mobiles.
                  </small>
                </h5>
              </div>
            </div>
          </div>

          <div
            class="col-md-6 col-lg-4 mb-5 mb-lg-0"
            data-aos="fade-right"
            data-aos-duration="1500"
          >
            <div class="px-4">
              <img
                v-lazy="'img/theme/agents.png'"
                class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                alt="statistique panneau mobile street marketing. Vélo publicitaire"
                style="width: 200px;"
              />
              <div class="pt-4 text-center">
                <h5 class="title">
                  <div class="d-block mb-1">AGENTS DÉPLOYÉS </div>
                  <small class="h6 text-muted">
                    +17 300 agents mobilisés pour assurer l’efficacité de nos campagnes.
                  </small>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style>

@media screen and (min-width: 701px) and (max-width: 1440px) {
  .lead{
    font-size: 18px;
  }
}
@media screen and (max-width: 700px) {
  h2{
    font-size: 2rem !important;
  }
  .lead{
    font-size: 16px;
  }
}
</style>
